﻿import {hasFlag, translation} from "@2d-front-monorepo/core";
import {
	getHiddenVehicleProperties, RequiredVehicleProperties,
	VehicleResult
} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useGlobalContext} from "../hooks/useGlobalContext";

export function VehicleComponent({vehicle}: { vehicle: VehicleResult }): JSX.Element {
	const data = vehicle.data;
	const {installation} = useGlobalContext();
	const hiddenProperties = getHiddenVehicleProperties(installation, vehicle.type);

	return <div className="columns gap padded">
		{!hasFlag(hiddenProperties, RequiredVehicleProperties.Plate) &&
		<dl className="title-desc col25">
			<dt>{translation(PermitTranslations.vehicle__plate)}</dt>
			<dd>{vehicle.plate}</dd>
		</dl>}

		{!hasFlag(hiddenProperties, RequiredVehicleProperties.Nickname) &&
		<dl className="title-desc col25">
			<dt>{translation(PermitTranslations.vehicle__nickname)}</dt>
			<dd>{data?.nickname || "—"}</dd>
		</dl>}

		{!hasFlag(hiddenProperties, RequiredVehicleProperties.Model) &&
		<dl className="title-desc col25">
			<dt>{translation(PermitTranslations.vehicle__model)}</dt>
			<dd>{data?.model || "—"}</dd>
		</dl>}

		{!hasFlag(hiddenProperties, RequiredVehicleProperties.Province) &&
		<dl className="title-desc col25">
			<dt>{translation(PermitTranslations.vehicle__province)}</dt>
			<dd>{data?.province || "—"}</dd>
		</dl>}
	</div>;
}
